<template>
  <b-overlay class="ticket-actions" :show="loading.ticket">
    <table class="w-50">
      <tr>
        <td><strong>Номер обращения:</strong></td>
        <td>{{ ticket.ID }}</td>
      </tr>
      <tr>
      <tr>
        <td><strong>Создатель:</strong></td>
        <td>{{ ticket.B2B_FEATURES.B2B_USER_NAME || 'Сотрудник B2С'}}</td>
      </tr>
      <tr>
        <td><strong>Статус:</strong></td>
        <td>
          <b-badge style="font-size: 0.9rem" class="font-weight-normal" :variant="variantBadge">{{
            ticket.get_status.NAME
          }}</b-badge>
        </td>
      </tr>
      <tr>
        <td><strong>Дата создания:</strong></td>
        <td>{{ ticket.CREATED_AT | formattedDateTime }}</td>
      </tr>
    </table>
  </b-overlay>
</template>

<script>
import { HOST_FOR_STORAGE } from "@/constants";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      hfs: HOST_FOR_STORAGE,
    };
  },

  computed: {
    ...mapGetters("tickets", ["ticket", "loading"]),
    ...mapGetters('auth' , ['currentUser']),

    isAdmin() {
      return this.currentUser.role.includes("administrator");
    },

    showButtons() {
      return this.ticket.get_status.ID === (1 || 2);
    },

    variantBadge() {
      switch (this.ticket.get_status.ID) {
        case 1:
          return "info";
        case 2:
          return "warning";
        case 3:
          return "danger";
        case 4:
          return "success";
        default:
          return "info";
      }
    },
  },

  methods: {
    ...mapActions("tickets", ["fetchTicket", "setStatusTicket"]),
  },
};
</script>
